/** @format */

import React from 'react';
import Workrouter from './ajax_login/workrouter';

import './workrouter.sass';

export default props => {
    const prefix = window.location.pathname.split('/')[1];
    return (
        <div
            className="workrouter-ajax-login"
            style={{
                backgroundImage: "url('/assets/images/workrouter-login-bg.jpg')",
                backgroundAttachment: 'fixed',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}>
            <div className="workrouter-ajax-login__center_container">
                <div
                    style={{
                        background: 'rgba(255,255,255,.7)',
                        padding: '24px 30px 30px',
                        border: 'solid 3px #ccc',
                        borderRadius: '10px 10px'
                    }}>
                    <h3 className="workrouter-ajax-login__title">
                        {prefix === 'remote' ? 'Color Checker' : 'Workrouter'}
                    </h3>
                    <div style={{minHeight: '210px'}}>
                        <Workrouter redirect={props.redirect} />
                    </div>
                </div>
                <div>
                    <a href="/" style={{color: 'white'}}>
                        Go to Main Website
                    </a>
                </div>
            </div>
        </div>
    );
};
